function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.2 0C0.537 0 0 0.537 0 1.2V9C0 9.3312 0.2688 9.6 0.6 9.6C0.9312 9.6 1.2 9.3312 1.2 9V1.2H9C9.3312 1.2 9.6 0.9312 9.6 0.6C9.6 0.2688 9.3312 0 9 0H1.2ZM3.6 2.4C2.937 2.4 2.4 2.937 2.4 3.6V10.8C2.4 11.463 2.937 12 3.6 12H10.8C11.463 12 12 11.463 12 10.8V3.6C12 2.937 11.463 2.4 10.8 2.4H3.6ZM3.6 3.6H10.8V10.8H3.6V3.6Z",
  fill: "white"
});

var SvgCopy = function SvgCopy(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCopy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/copy.65c43860.svg";
export { ForwardRef as ReactComponent };